import { api } from 'src/api/api';
import {
  getPaymentOptionsErrorMessage,
  getPaymentPlanErrorMessage,
  createAgreementErrorMessage,
  confirmPaymentErrorMessage,
} from 'src/helpers/defaultErrorMessages';
import { isUserFriendlyError } from 'src/helpers/apiHelper';

export function getPaymentOptions(body, isLoading, onSuccess, onError) {
  isLoading(true);
  return api.post('/api/payment/options', body).then(
    (response) => {
      if (isUserFriendlyError(response)) {
        onError({ message: response.data.errorMessage, errorCode: response.data.errorCode });
      } else onSuccess(response, body.isForAgreement, body.claimIds);

      isLoading(false);
    },
    (error) => {
      const { response } = error;
      onError({
        message: isUserFriendlyError(response) ? response.data.errorMessage : getPaymentOptionsErrorMessage,
      });
      isLoading(false);
    }
  );
}

export function getPaymentPlan(body, isLoading, onSuccess, onError, isForAgreement = false) {
  isLoading(true);

  const endpoint = isForAgreement ? '/api/Agreement/plan' : '/api/payment/plan';

  return api.post(endpoint, body).then(
    (response) => {
      if (isUserFriendlyError(response)) {
        onError({ message: response.data.errorMessage });
      } else onSuccess(response);

      isLoading(false);
    },
    (error) => {
      const { response } = error;
      onError({
        message: isUserFriendlyError(response) ? response.data.errorMessage : getPaymentPlanErrorMessage,
      });
      isLoading(false);
    }
  );
}

export async function getAuthenticationHtml(body, isLoading) {
  isLoading(true);
  return api
    .post('/api/payment/authenticateCard', body)
    .then((response) => {
      return response;
    })
    .finally(() => {
      isLoading(false);
    });
}

export function createAgreement(body, isLoading, onSuccess, onError) {
  isLoading(true);
  return api
    .post('/api/agreement', body)
    .then(
      (response) => {
        if (isUserFriendlyError(response) && response.status !== 202) {
          onError({ message: response.data.errorMessage });
        } else onSuccess(response.data);
      },
      (error) => {
        const { response } = error;
        onError({
          message: isUserFriendlyError(response) ? response.data.errorMessage : createAgreementErrorMessage,
        });
      }
    )
    .finally(() => {
      isLoading(false);
    });
}

export async function confirmPayment(body, isLoading, onSuccess, onError) {
  isLoading(true);
  return api
    .post('/api/payment/pay', body)
    .then((response) => {
      if (
        response.data.errorCode !== 'COL_000020' && // Payment successful but payment reporting failed
        isUserFriendlyError(response)
      ) {
        onError({ message: response.data.errorMessage });
      } else onSuccess(response.data);
    })
    .catch(() => {
      onError(confirmPaymentErrorMessage);
    })
    .finally(() => {
      isLoading(false);
    });
}
